export const firebaseConfig = {
  apiKey: "AIzaSyDcHW0euzNBI550cgb9VBRCMU6XqFQ2-1U",
  authDomain: "darshnisoftware-100.firebaseapp.com",
  projectId: "darshnisoftware-100",
  storageBucket: "darshnisoftware-100.firebasestorage.app",
  messagingSenderId: "256962723716",
  appId: "1:256962723716:web:48a80162bb2399896667d1",
  measurementId: "G-1BDHC6Z980"
};